import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToId, STORE } from "../lib/store";

const LINKS = [
    { id: "inventory", label: "Inventory", testid: "nav-inventory-link" },
    { id: "savings", label: "Savings", testid: "nav-savings-link" },
    { id: "showroom", label: "Showroom", testid: "nav-showroom-link" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const { scrollYProgress } = useScroll();
    const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 24 });

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
                scrolled ? "bg-ink/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
            }`}
        >
            <motion.div style={{ scaleX: progress }} className="h-[2px] origin-left bg-gold" />
            <div className="mx-auto max-w-[1440px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
                <button
                    data-testid="nav-brand-logo"
                    onClick={() => scrollToId("top")}
                    className="flex items-center gap-3 group text-left"
                >
                    <span className="grid place-items-center h-9 w-9 bg-gold text-ink font-display font-800 font-extrabold text-sm transition-transform duration-300 group-hover:rotate-90">
                        K
                    </span>
                    <span className="leading-none hidden sm:block">
                        <span className="block font-display font-bold text-sm tracking-wide">KARAGNA</span>
                        <span className="block font-mono text-[10px] tracking-[0.35em] text-gold">.COM</span>
                    </span>
                </button>

                <nav className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={l.testid}
                            onClick={() => scrollToId(l.id)}
                            className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-300 hover:text-gold transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <a
                    href={STORE.phoneHref}
                    data-testid="nav-phone-cta"
                    className="flex items-center gap-2 rounded-full bg-gold px-4 md:px-5 py-2.5 font-mono text-[11px] md:text-xs font-bold tracking-widest text-ink transition-all duration-300 hover:bg-white hover:scale-[1.03]"
                >
                    <Phone className="h-3.5 w-3.5" />
                    {STORE.phoneDisplay}
                </a>
            </div>
        </header>
    );
}
